// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import { setAnswer } from '../../redux/rating';

import Box from '../../components/Box';

import { Questions } from '../../assets/model';

type Props = {
  setAnswer: (text: string) => void,
  onClick: () => void,
  question: number,
  small?: boolean
};

type State = {};

class TypeOfProperty extends React.Component<Props, State> {
  render(): React.Node {
    const { question } = this.props;
    return (
      <div className="house">
        {Questions[question].answers.map((answer, i) => {
          return (
            <Box
              small={this.props.small}
              key={i}
              onClick={() => {
                this.props.onClick(this.props.question, answer);
              }}
              question={answer.text}
            />
          );
        })}
      </div>
    );
  }
}

export default connect(state => ({ state }), { setAnswer })(TypeOfProperty);



// WEBPACK FOOTER //
// ./src/components/questions/TypeOfProperty.js